/* LEANEN theme JS */
(function () {
  'use strict';

  // ---- Size / variant selection on spotlight + product forms ----
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var variantsEl = form.querySelector('[data-variants]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var addBtn = form.querySelector('[data-add]');
    var sizeBtns = form.querySelectorAll('.size');

    function money(cents) {
      return 'Rs ' + (cents / 100).toLocaleString('en-PK');
    }

    function select(btn) {
      sizeBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      var vid = btn.getAttribute('data-variant-id');
      if (idInput && vid) idInput.value = vid;
      var v = variants.filter(function (x) { return String(x.id) === String(vid); })[0];
      if (v && priceEl) priceEl.textContent = money(v.price);
      if (addBtn) {
        var avail = v ? v.available : true;
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? (addBtn.getAttribute('data-label') || 'Add to Bag') : 'Sold out';
      }
    }

    sizeBtns.forEach(function (btn) {
      if (btn.disabled) return;
      btn.addEventListener('click', function () { select(btn); });
    });

    // preselect first available size
    var first = Array.prototype.filter.call(sizeBtns, function (b) { return !b.disabled; })[0];
    if (first) select(first);

    // AJAX add to cart with graceful fallback
    form.addEventListener('submit', function (e) {
      if (!form.getAttribute('data-ajax')) return; // demo mode: let it submit / no-op
      e.preventDefault();
      if (addBtn && addBtn.disabled) return;
      var body = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: body, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          updateBag(cart.item_count);
          flash(addBtn);
          toast(form);
        })
        .catch(function () { form.submit(); });
    });
  });

 document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var track = gal.querySelector('[data-gal-track]');
    if (!track) return;
    var slides = track.querySelectorAll('.gal__slide');
    if (slides.length < 2) return;
    var dots = gal.querySelectorAll('[data-gal-dot]');
    var prev = gal.querySelector('[data-gal-prev]');
    var next = gal.querySelector('[data-gal-next]');
    var idx = 0;

    function go(i) {
      idx = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive();
    }
    function setActive() {
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var nearest = 0, min = Infinity;
        slides.forEach(function (s, i) {
          var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < min) { min = d; nearest = i; }
        });
        idx = nearest; setActive();
      });
    });
    setActive();
  });

  function updateBag(count) {
    document.querySelectorAll('[data-bag-count]').forEach(function (el) { el.textContent = count; });
  }

  function flash(btn) {
    if (!btn) return;
    var old = btn.textContent;
    btn.textContent = 'Added ✓';
    setTimeout(function () { btn.textContent = old; }, 1400);
  }

  // ---- Slide-in confirmation with a direct path to checkout ----
  var toastEl, toastTimer;
  function ensureToast() {
    if (toastEl) return toastEl;
    toastEl = document.createElement('div');
    toastEl.setAttribute('data-toast', '');
    toastEl.style.cssText = [
      'position:fixed', 'top:24px', 'right:24px', 'z-index:9999',
      'max-width:340px', 'background:#111', 'color:#fff',
      'font-family:inherit', 'padding:18px 20px', 'border-radius:14px',
      'box-shadow:0 12px 40px rgba(0,0,0,.28)',
      'transform:translateX(120%)', 'transition:transform .38s cubic-bezier(.16,1,.3,1)',
      'display:flex', 'flex-direction:column', 'gap:12px'
    ].join(';');
    document.body.appendChild(toastEl);
    return toastEl;
  }

  function toast(form) {
    var el = ensureToast();
    var title = (form.getAttribute('data-title') || 'Item') + ' added to bag';
    el.innerHTML =
      '<div style="display:flex;align-items:center;gap:10px;font-size:15px;font-weight:600;letter-spacing:.01em">' +
        '<span style="display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:#fff;color:#111;font-size:13px">\u2713</span>' +
        '<span>' + title + '</span>' +
      '</div>' +
      '<div style="display:flex;gap:10px">' +
        '<a href="/cart" style="flex:1;text-align:center;padding:11px 12px;border-radius:10px;border:1px solid rgba(255,255,255,.4);color:#fff;text-decoration:none;font-size:13px;font-weight:600">View bag</a>' +
        '<a href="/checkout" style="flex:1;text-align:center;padding:11px 12px;border-radius:10px;background:#fff;color:#111;text-decoration:none;font-size:13px;font-weight:700">Checkout</a>' +
      '</div>';
    requestAnimationFrame(function () { el.style.transform = 'translateX(0)'; });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.style.transform = 'translateX(120%)'; }, 5000);
  }
})();